export default {
  "TopSummary.TabTitle": "ホーム",
  "TopSummary.Title": "パーソナルデータダッシュボード\n(法人のお客さま向け)",
  "TopSummary.Text":
    "ドコモおよびNTTドコモビジネス株式会社は法令順守はもちろんのこと、お客さまのプライバシーに十分配慮した上で、お一人おひとりに便利・おトクをお届けし、社会貢献できるよう、データを有効に活用して参ります",
  "TopSummary.SubTextStart": "※ドコモのプライバシーに対する取組みは",
  "TopSummary.SubTextLink": "こちら",
  "TopSummary.SubTextEnd": "(プライバシー影響評価)",
}
